import React from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as SVGICONS from '../../images/img/images';
import * as signinActions from '../../actions/signinActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	Modal,
	// ModalHeader,
	// ModalTitle,
	// ModalClose,
	// ModalBody,
	// ModalFooter,
} from 'react-bootstrap';
import classNames from 'classnames';
import validator from './validator';
const autoBind = require('auto-bind');

//login container component
class Forgot extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		console.log('props', this.props)
		this.state = {
			email: { value: '', isValid: true, message: '' },
			spinner: false
		};
		//binding current context to all functions
		this.onForgotHandler = this.onForgotHandler.bind(this);


	}

	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}


	onChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "email") {
			if (e.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		}
		this.setState(state);
	}
	componentWillReceiveProps(nextProps) {

		if (nextProps.forgotData && nextProps.forgotData.success) {
			this.props.hideForgotModal();
			this.setState({ spinner: false })
		} else {
			this.setState({ spinner: false })
		}
	}

	//Handler for sign-up
	onForgotHandler(event) {
		event.preventDefault();
		var state = this.state;
		if (state.email || !state.email) {
			if (state.email.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					state.email.isValid = true;
					state.email.message = '';
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		}
		if (this.state.email.value != '' && (this.state.email.message == '' || this.state.email.message == undefined)) {
			this.setState({ spinner: true })
			var obj = {
				email: this.state.email.value,
			}
			this.props.actions.forgotPassword(obj);
		}
	}


	render() {
	
		var { email } = this.state;
		var emailGroupClass = classNames('input-group', { 'has-error': !email.isValid });
		return (
			<Modal show={this.props.forgotModalOpen} size="modal-sm" onHide={(e) => this.props.hideForgotModal(e)}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hideForgotModal} /> */}
					<Modal.Title><img src={require('../../images/images/forgt_passwrd.svg')} alt="" /></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* <ToastContainer /> */}
					<form className="signup-form" id="loginForm" onSubmit={this.onForgotHandler}>

						<div className="signIn changePass" style={{ "fontSize": "21" }}>Reset password</div>
						<p style={{ "textAlign": "center", "fontSize": "14" }}>We will send the password reset instructions to the email address for the account</p>

						<div className="loginInput">
							<div className="input-group">
								<div className="input-group-prepend">
									<span className="input-group-text" id="inputGroupPrepend">
										<SVGICONS.EmailSvg />
									</span>
								</div>
								<input type="text" name="email" className="form-control"
									placeholder="Email address" value={email.value} onChange={this.onChange} autoFocus onClick={this.handlePopover} />
								<span className="help-block">{email.message}</span>
							</div>
							<div className="btngrouplogIn ">
								{/* <Link href="" className="hidediv1"><i className="fa fa-angle-left"></i> Back</Link> */}
								<button onClick={this.props.closeForgotModal} className="btn btn-back btn-signup pull-left" data-toggle="modal" data-target="#exampleModal">{"<"}Back</button>

								<button type="submit" className="btn btn-primary btn-signup pull-right" data-toggle="modal" >Submit {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>

							</div>

						</div>
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		forgotData: state.signin.forgotData
	};
}

// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(signinActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Forgot);
// export default (Signup);
